import styled from 'styled-components'

export const Button = styled.button`
  margin: 1rem 0;
  background: ${({theme}) => theme.primary};
  opacity: .9;
  border: none;
  color: #fff;
  padding: .3rem;
  width: 200px;
  box-shadow: 0 0 5px #9c9c9c;
  
  &:hover {
    opacity: 1;
  }
  
  &, &:focus {
    outline: none;
  }
`

export const ButtonNeutral = styled(Button)`
  background: ${({theme}) => theme.darkGray};
  box-shadow: 0 0 5px ${({theme}) => theme.gray};
`
